(function () {
  const KEY = "collectionScrollState_v2";

  function getNextPageNumber() {
    // Stretch: <pagination-load-button data-url="/collections/cama?page=2">
    const btn = document.querySelector("pagination-load-button[data-url*='page=']");
    if (!btn) return 1;

    const url = btn.getAttribute("data-url") || "";
    const m = url.match(/[\?&]page=(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  }

  // Guarda estado ao clicar num produto
  document.addEventListener(
    "click",
    function (e) {
      const a = e.target.closest('a[href*="/products/"]');
      if (!a) return;

      if (!location.pathname.includes("/collections/")) return;
      if (a.target === "_blank" || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      const state = {
        url: location.pathname + location.search,
        y: window.scrollY,
        nextPage: getNextPageNumber(), // ex.: 2 significa que já tens a página 1 carregada
        ts: Date.now()
      };

      sessionStorage.setItem(KEY, JSON.stringify(state));
    },
    true
  );

  async function clickLoadMoreUntil(targetNextPage) {
    // targetNextPage = o "next page" que existia quando saíste.
    // Se targetNextPage era 4, significa que tinhas carregado até page=3.
    while (true) {
      const btn = document.querySelector("pagination-load-button[data-url*='page=']");
      if (!btn) break;

      const url = btn.getAttribute("data-url") || "";
      const m = url.match(/[\?&]page=(\d+)/);
      const currentNext = m ? parseInt(m[1], 10) : 1;

      // Já carregámos o suficiente
      if (currentNext >= targetNextPage) break;

      // Esperar que o grid aumente após clicar
      const grid = document.getElementById("ShopProductsGrid") || document.querySelector("[data-container-id='ShopProductsGrid']");
      const before = grid ? grid.querySelectorAll('[data-target="shop__grid-item"]').length : 0;

      btn.click();

      await new Promise((resolve) => {
        const timeout = setTimeout(resolve, 2000);

        if (!grid) return;

        const obs = new MutationObserver(() => {
          const after = grid.querySelectorAll('[data-target="shop__grid-item"]').length;
          if (after > before) {
            clearTimeout(timeout);
            obs.disconnect();
            resolve();
          }
        });

        obs.observe(grid, { childList: true, subtree: true });
      });
    }
  }

  async function restore() {
    if (!location.pathname.includes("/collections/")) return;

    const raw = sessionStorage.getItem(KEY);
    if (!raw) return;

    let state;
    try {
      state = JSON.parse(raw);
    } catch (_) {
      return;
    }

    const current = location.pathname + location.search;
    if (state.url !== current) return;

    // expira em 30 min
    if (Date.now() - state.ts > 30 * 60 * 1000) {
      sessionStorage.removeItem(KEY);
      return;
    }

    // 1) garantir que as páginas "ver mais" estão carregadas
    await clickLoadMoreUntil(state.nextPage);

    // 2) restaurar scroll
    requestAnimationFrame(() => {
      setTimeout(() => {
        window.scrollTo(0, Number(state.y) || 0);
      }, 60);
    });

    sessionStorage.removeItem(KEY);
  }

  // pageshow é essencial para back/forward cache
  window.addEventListener("pageshow", () => {
    restore();
  });
})();
